import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store"
import LoggerService from './common/logger.service'
import ApiService from "./common/api.service"
import VueScrollTo from 'vue-scrollto'

Vue.config.productionTip = false

LoggerService.init();
ApiService.init();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.use(VueScrollTo)